<template>
  <section class="bg-[#0F0F0F] py-20 px-6 md:px-10 lg:px-40">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
      <!-- Card 1 -->
      <div class="group relative rounded-xl overflow-hidden shadow-2xl">
        <NuxtLink to="/block" class="block w-full aspect-video">
          <img
            src="/assets/images/card-image1.webp"
            :alt="t('card.course_alt')"
            class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div
            class="absolute inset-0 bg-black/50 flex flex-col items-center justify-center text-center px-4"
          >
            <img
              src="/assets/images/motorcycle-solid.svg"
              alt="Icon"
              class="w-20 h-20 md:w-24 md:h-24 mb-3 opacity-80"
            />
            <h3 class="text-white text-2xl md:text-3xl font-bold">
              {{ t("card.course_title") }}
            </h3>
          </div>
        </NuxtLink>
      </div>

      <!-- Card 2 -->
      <div class="group relative rounded-xl overflow-hidden shadow-2xl">
        <NuxtLink to="/daily-blog" class="block w-full aspect-video">
          <img
            src="/assets/images/card-image2.webp"
            :alt="t('card.blog_alt')"
            class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div
            class="absolute inset-0 bg-black/50 flex flex-col items-center justify-center text-center px-4"
          >
            <img
              src="/assets/images/motorcycle-solid.svg"
              alt="Icon"
              class="w-20 h-20 md:w-24 md:h-24 mb-3 opacity-80"
            />
            <h3 class="text-white text-2xl md:text-3xl font-bold">
              {{ t("card.blog_title") }}
            </h3>
          </div>
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from "#imports";

const { t } = useI18n();
defineOptions({ name: "CardSection" });
</script>
